export default "__VITE_ASSET__67sdNY7P__"